/**
 * Create a JSON that can be used in a PR JSON object
 * @param {PurchaseRequest} purchaseRequest
 * @return {string}
 */
export const createPRJson = (purchaseRequest) => {
    return JSON.stringify(purchaseRequest.getPurchaseRequest());
};
/**
 * Create a JSON that can be used in a PR JSON object
 * @param {PurchaseRequest} purchaseRequest
 * @return {string}
 */
export const createPRJsonWithSubmissionDate = (purchaseRequest) => {
    const PRJson = purchaseRequest.getPurchaseRequest();
    PRJson.submissionDate = new Date().toUTCString();
    return JSON.stringify(PRJson);
};

